import React from 'react'
import GoogleSvg from '../../assets/google.svg'
import {MailIcon} from '@heroicons/react/outline'

const UserRow = (props) => {
  return (
    <div className="flex items-center gap-5 p-3 rounded-lg hover:bg-slate-50">
        <div className="flex items-center w-1/3 gap-3">
            <img src={props.data.pic} alt={props.data.name + " Profile Pic"} className="w-10 h-10 rounded-full" />
            <span>{props.data.name}</span>
        </div>
        <div className="w-1/3">{props.data.email}</div>
        <div className="w-1/12 ">{props.data.gender}</div>
        <div className="w-1/12">{props.data.birthday}</div>
        <div className="flex justify-center w-1/12">
            {
              props.data.login_by === 'Google' 
              ? <img src={GoogleSvg} alt="google" className='w-5 h-5' />
              : <MailIcon className='w-5 h-5' />
            }
        </div>
        <div className="w-1/6">
            {props.data.joined_at}
        </div>
    </div>
  )
}

export default UserRow